import {scene1Frames} from './scene1.frames';
import {scene2Frames} from './scene2.frames';
import {scene3Frames} from './scene3.frames';
import {scene4Frames} from './scene4.frames';

export const allFrames = {
    scene1Frames,
    scene2Frames,
    scene3Frames,
    scene4Frames
};
